export default {
  'to-ss': 'Mintegral 广告主投放平台',
  domain: {
    tips: {
      title: '域名更换通知',
      content:
        '为了提供更稳定的服务，我们已更新访问地址。当前域名即将停用，请前往新域名继续使用。您需要重新登录以确保正常访问。',
      submit: '立即跳转',
    },
  },
  'to-helper': '帮助中心',
  confirmTitle: '是否要删除当前项目？',
  confirmTips: '当前项目会被删除，没法恢复。',
  confirmButtonText: '确认',
  cancelButtonText: '取消',
  enterPlaceHolder: '请填写',
  agreement: '保密协议',
  createVersionDialog: {
    version: '版本',
    title: '新建项目',
    createSuccessText: '创建成功',
    confirmText: '确 认',
    cancleText: '取 消',
    form: {
      name: {
        label: '项目名称',
        placeholder: '请输入版本名称',
        required: '版本名称不能为空',
        length: '长度不能超过 50 个字符',
        format: '仅可输入字母、数字、下划线（不支持输入空格）',
        duplicateName: '该名称已存在',
      },
      description: {
        placeholder: '请输入版本描述',
        required: '版本描述不能为空',
        length: '长度不能超过 500 个字符',
      },
    },
  },
  downloadTaskDialog: {
    title: '压缩列表',
    loading: '正在压缩',
    failed: '压缩失败',
    running: {
      a: '正在压缩',
      b: '个文件',
    },
    download: '点击下载',
    packed: '已压缩',
    stopDialog: {
      message: '要中止压缩吗？',
      content: '文件压缩尚未完成无法下载，要中止吗？',
      keep: '继续下载',
      cancel: '取消下载',
    },
  },
  playUnitTitle: '快捷排版',
  fontForbidden: {
    msg: '此项目中包含已下架字体，请重新选择字体',
    set: '去设置',
    cancel: '取消',
    ok: '了解',
    msgDialog: '以下字体已丢失，无法使用，请重新选择字体进行替换。',
  },
  downloadVersionDialog: {
    title: '作品下载',
    version: {
      new: '最新版本',
      history: '历史版本',
    },
    package: {
      status: {
        label: '状态',
        ready: '未下载',
        done: '已下载',
      },
      zipType: {
        label: '压缩方式',
        normal: '智能压缩（平衡文件质量与大小）',
        custom: '自定义压缩',
      },
      downloadNotice: '请勾选渠道',
      previewTitle: '包体压缩预览',
      back: '返回下载',
      label: '包体控制',
      image: '质量',
      qualityLabel: {
        normal: '质量选择',
        image: '图片质量',
        video: '视频质量',
        audio: '音频质量',
      },
      counting: '打包计算中',
      apply: '应用并计算',
      preview: '预览',
      desc: '实际包体',
      fileSize: '包体大小',
      limit: '无限制',
    },
    downloadTips:
      '此渠道下载的文件不能用于投放，建议使用【推送】功能，一键推送至Mintergral广告主自助投放平台进行内审并投放。',
    deploymentTips:
      '下载Inmobi可玩素材后，需要将离线脚本内容部署到CDN上，再手动修改html中的路径，素材才能正常使用。',
    eventDetectionTips: '请设置结束场景或试玩结束事件后重试。',
    mtgDisabledTips: '无需下载，可一键推送至Mintegral广告主自助投放平台',
    notProduct: '请先选择产品信息',
    unauthorized: '渠道未授权',
    channelLable: {
      mintegral: '自有渠道',
      other: '外部渠道',
      choose: '渠道选择',
    },
    table: {
      column: {
        channel: '渠道',
        platform: '平台',
      },
      action: {
        checkall: '全选',
      },
      disabledDownload: '此渠道不支持下载',
    },
    download: '下载',
    copylink: '获取链接',
    wxgame: {
      disableTips: '当前项目使用了不支持微信的特性，请调整后再次尝试。',
      ctaTips: '*微信小游戏渠道不支持跳转应用商店，请删减相关CTA按钮或环节。',
      previewTips: '微信小游戏试玩不支持预览，可通过预览项目查看试玩效果。',
    },
  },
  plPreview: {
    history: {
      tips: '历史版本仅支持再次下载已下载的渠道，不支持二次推送。',
    },
    crumb: {
      ps: {
        title: '可玩自由编辑器',
      },
    },
    creativeName: {
      placeHolder: '请输入创意名称',
    },
  },
  pushDialog: {
    title: '推送',
    accountOptions: {
      local: '当前账户',
      other: '其他账户',
      new: '新增帐号',
    },
    cancleLabel: '取 消',
    confirmLabel: '确 认',
    form: {
      accountType: {
        label: '推送账号',
        message: '请选择推送账户',
        placeholder: '请选择推送账户',
      },
      name: {
        label: '账户',
        message: '请输入用户名或者邮箱',
        placeholder: '请输入用户名或邮箱',
      },
      password: {
        label: '密码',
        message: '请输入密码',
        placeholder: '请输入密码',
      },
    },
    packageManager: {
      remainLable: '下载量剩余',
      totalLabel: '总量',
      remainTips: {
        A: '总量 = 30天下载量 + 额外补充下载量',
        B: '每30天重置下载量（额外补充的除外）',
      },
      progress: {
        network: '渠道',
        version: '作品',
        download: '下载量',
      },
      overTips: '您当前选中数量已大于剩余下载量，请减量。',
      mintegral: 'Mintegral渠道下载不计入下载量',
    },
    pushSuccess: '推送成功',
    pushSuccessA: '推送成功',
  },
  pushInfoConfirm: {
    title: '提示',
    cancel: '取 消',
    info: '补充信息',
    emptyText: '缺少产品信息无法使用该功能，请补充产品信息',
  },
  eventInfoConfirm: {
    title: '无法{title}',
    info: '前往设置',
    setUp: '查看如何设置',
    emptyInstallText:
      '当前项目缺少跳转应用商店事件，请重新设置后再进行{info}。',
    emptyGameEndText:
      '当前项目缺少结束场景或上报试玩结束事件，请重新设置后再进行{info}。',
    emptyNullText:
      '当前项目缺少跳转应用商店事件、结束场景或上报试玩结束事件，请重新设置后再进行{info}。',
  },
  pushRecordDialog: {
    title: 'Mintegral 推送记录',
    emptyText: '此素材尚未推送到 Mintegral 广告投放平台',
    closeLabel: '关闭',
    goToAdPlatform: '前往 Mintegral 广告主自助投放平台',
    table: {
      title: '作品名称',
      language: '语言',
      platform: '平台',
      advName: '推送账号',
      status: '状态',
      updateTime: '推送时间',
      action: '操作',
      preview: '预览',
      download: '下载',
      info: '项目信息',
    },
    statusList: {
      pending: '审核中',
      approved: '推送成功',
      rejected: '不通过',
      failed: '推送失败',
      downloaded: '已下载',
      other: '其他原因',
    },
  },
  historyList: {
    table: {
      column: {
        count: '扣减次数',
        countAll: '扣减次数总计',
        templateName: '模板名称',
        time: '操作时间',
        fingerprintCount: '等{num}个指纹',
        basicId: '创意ID及名称',
        creative_version: '创意版本名称',
        basicIdCount: '等多个创意版本ID',
      },
    },
  },
  pushdownloadRecordDialog: {
    title: '导出 & 下载历史',
    emptyText: '当前列表为空',
    table: {
      count: '扣减次数',
      channel: '渠道',
      updateTime: '创建时间',
      fingerprint: '素材指纹',
      export: '导出Excel',
    },
    search: {
      isDecuction: '是否扣减次数',
      decuction: '扣减',
      notDecuction: '不扣减',
      channel: '筛选渠道',
      platform: '筛选平台',
    },
    infoDialog: {
      lang: '语言',
      account: '推送账户',
    },
  },
  versionBar: {
    exportButton: '导出',
    createGuide: '新增版本',
    copyButton: '复制版本',
    deleteButton: '删除版本',
    deleteSuccess: '删除成功',
    switchSuccess: '切换成功',
    deleteForbidden: '当前编辑版本，无法删除',
    saveWarningText: '素材保存中，请勿执行其它操作',
    deleteConfirm: {
      title: '提示',
      content: '是否确认删除该版本？',
      header: '已选项目',
      confirmButtonText: '确认',
      cancelButtonText: '取消',
    },
    option: {
      copyButton: '复制',
      deleteButton: '删除',
      downloadButton: '下载',
      copyToMulti: '复制至多组合',
      copyToPs: '复制至自由编辑',
      copyToDco: '复制至 DCO',
    },
    saveConfirm: {
      type: {
        copy: '复制',
        choose: '切换版本',
        create: '创建',
        export: '导出',
      },
      content: '是否保存当前版本？',
      title: '提示',
      confirmButtonText: '是',
      cancelButtonText: '否',
    },
  },
  langSelector: {
    label: '默认语言',
  },
  errorpage: {
    message: '链接有误，请重新输入',
    homeButton: '返回首页',
  },
  listNav: {
    menu: {
      normal: '普通制作',
      dco: 'DCO制作',
      multi: '多组合制作',
    },
    starButton: '收藏',
  },
  previewDialog: {
    preview: '预览',
    copyText: '请复制链接到浏览器即可预览',
    copyButton: '复制',
    reloadButton: '重新播放',
    replay: '重播',
    product: '产品',
    playable: '项目',
    versionName: '版本名称',
    dcoid: '组合ID',
    dcoIdDesc: '一个 DCO ID 下会有多种组合方式，每个组合即为一个组合ID',
    dcoConfiguration: 'DCO 配置',
    createVersion: '新建项目',
    createMultiVersion: '新增多组合项目',
    createDCOVersion: '新增DCO版本',
    editVersion: '编辑版本',
    copyVersion: '复制项目',
    copyMultiVersion: '复制多组合项目',
    copyNewDCOVersion: '复制DCO版本',
    versionManagement: '版本管理',
  },
  save: {
    autoSaving: '自动保存中…',
    saved: '所有更改已保存',
    text: '保存',
    fail: '保存失败',
  },
  validate: {
    numberOnly: '仅支持数字查询',
  },
  balanceThresholdTips:
    '您的账户余额已不足 $ {balance_threshold}, 为了不影响您的使用，请及时充值。',
  network: {
    networkException: '网络异常，请刷新重试。',
  },
  poinitManagement: {
    desc: '添加埋点后素材将支持交互数据分析、场景分析、用户旅程分析等高级分析功能',
    select: {
      tips: '勾选后，对应渠道之后下载/推送的所有可玩素材将添加埋点代码。（目前仅支持以上渠道，如需支持其他渠道请联系商务） 反之则不添加,建议允许添加埋点，添加埋点后素材将支持交互数据分析、场景分析、用户旅程分析等高级分析功能。',
    },
  },
}
